/**
 * 小さな確認ダイアログ（ブラウザ標準の confirm は使わない。アプリ内で止まるため）。
 *
 * - role=dialog＋aria-modal。見出しを aria-labelledby、本文を aria-describedby で結ぶ
 * - Tab は中だけで回る（modalFocus の見張りに `data-focus-trap` で乗る）
 * - Esc・外側のタップで「やめる」と同じ。後ろのモーダルまで Esc で閉じないよう、ここで止める
 * - 閉じたら、開く前にフォーカスがあった所へ戻す
 */

let serial = 0;

export function confirmDialog(options: {
  title: string;
  body?: string;
  okLabel: string;
  cancelLabel?: string;
}): Promise<boolean> {
  return new Promise((resolve) => {
    const id = `confirm-dialog-${++serial}`;
    const opener = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    const root = document.createElement('div');
    root.className = 'mock-ad confirm-dialog';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-labelledby', `${id}-title`);
    root.dataset.focusTrap = 'true';
    root.dataset.visible = 'false';
    const card = document.createElement('div');
    card.className = 'mock-ad__card';
    const title = document.createElement('h2');
    title.className = 'mock-ad__title';
    title.id = `${id}-title`;
    title.textContent = options.title;
    card.append(title);
    if (options.body) {
      const body = document.createElement('p');
      body.className = 'mock-ad__body';
      body.id = `${id}-body`;
      body.textContent = options.body;
      root.setAttribute('aria-describedby', body.id);
      card.append(body);
    }
    const actions = document.createElement('div');
    actions.className = 'mock-ad__actions';
    let done = false;
    const finish = (value: boolean) => {
      if (done) return;
      done = true;
      document.removeEventListener('keydown', onKey, true);
      root.dataset.visible = 'false';
      root.remove();
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
      resolve(value);
    };
    const onKey = (event: KeyboardEvent) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      finish(false);
    };
    const cancel = document.createElement('button');
    cancel.type = 'button';
    cancel.className = 'btn';
    cancel.textContent = options.cancelLabel ?? 'やめる';
    cancel.addEventListener('click', () => finish(false));
    const ok = document.createElement('button');
    ok.type = 'button';
    ok.className = 'btn btn--primary';
    ok.textContent = options.okLabel;
    ok.addEventListener('click', () => finish(true));
    actions.append(cancel, ok);
    card.append(actions);
    root.append(card);
    root.addEventListener('click', (event) => {
      if (event.target === root) finish(false);
    });
    // 後ろのモーダル（設定・ショップなど）の Esc より先に受ける
    document.addEventListener('keydown', onKey, true);
    document.body.append(root);
    // 付けてから見える印を立てる（modalFocus は属性の変化で気づく）
    root.dataset.visible = 'true';
    cancel.focus();
  });
}
